import type { Translations } from '../../types'

const homepageMessages: Translations = {
  "homepage.heading": "Contenuti homepage",
  "homepage.loadingSettings": "Recupero impostazioni homepage...",
  "homepage.currentSlug": "Slug attuale",
  "homepage.loadingPage": "Sto caricando la homepage...",
  "homepage.missingPage": "Seleziona o crea la homepage dal CMS.",
  "homepage.reload": "Ricarica homepage",
  "homepage.loginRequired": "Effettua il login per modificare la homepage.",
  "homepage.settingsError": "Impossibile leggere le impostazioni homepage.",
  "homepage.saveSettings": "Salva impostazioni",
  "homepage.savingSettings": "Salvataggio...",
  "homepage.settings.title": "Impostazioni homepage",
  "homepage.settings.subtitle": "Brand, slug, link e footer.",
  "homepage.settings.remove": "Rimuovi",
  "homepage.settings.addLink": "Aggiungi",
  "homepage.settings.shopName": "Nome shop",
  "homepage.settings.slug": "Slug homepage",
  "homepage.settings.tagline": "Tagline header",
  "homepage.settings.logoUrl": "Logo URL",
  "homepage.settings.primaryColor": "Colore primario",
  "homepage.settings.headerLinks": "Link header",
  "homepage.settings.socialLinks": "Social links",
  "homepage.settings.footerTitle": "Footer",
  "homepage.settings.footerNote": "Note footer",
  "homepage.settings.footerLinks": "Link footer"
}

export default homepageMessages
